module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/files/group-folders-4146673456c35756ceda859d9c276568.svg";